export default function PageHeader({ title, subtitle, breadcrumbs = [], actions }) {
  return (
    <div className="border-b border-slate-800 bg-slate-950/80 backdrop-blur sticky top-0 z-20">
      <div className="px-4 sm:px-6 lg:px-8 py-4 sm:py-5 flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono mb-1">
            {breadcrumbs.join(" · ")}
          </div>
          <h1 className="text-2xl font-bold text-slate-50 tracking-tight">{title}</h1>
          {subtitle ? (
            <p className="text-sm text-slate-400 mt-0.5">{subtitle}</p>
          ) : null}
        </div>
        {actions ? <div className="w-full sm:w-auto shrink-0">{actions}</div> : null}
      </div>
    </div>
  );
}
